import type { PlgPermissionService } from '@/domains/shared/services/base-plg-permission-service';

export type { CheckPLgPermissionOptions } from '@/domains/shared/services/base-plg-permission-service';

/**
 * 查新模块编辑权限服务
 *
 * 用于判断当前用户是否有权限编辑查新模块内容
 */
export interface NoveltyCheckPermissionService extends PlgPermissionService {}

export const NoveltyCheckPermissionService = Symbol.for('NoveltyCheckPermissionService');
